export function parseSourceFilterParam(value: string | null): string[] | undefined {
  if (!value) return undefined;
  return value
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean);
}

export function sourceFilterToParam(sourceIds: string[]): string | null {
  if (sourceIds.length === 0) return null;
  return sourceIds.join(',');
}
